
import apiClient from "../utils/axiosInterceptor";
export const CountriesDropdownApi = async () => {
    try {
        const response = await apiClient.get(`fapp-core-api/api/countries`);
        return response;
    } catch (error: any) {
        console.error("Error fetching countries:", error);
        return error.response?.status || 500;
    }
};

export const fetchEntraUsers = async (searchText: any) => {
    try {
        const response = await apiClient.get(`fapp-core-api/api/Users?search=${searchText}`);
        return response;
    } catch (error: any) {
        console.error("Error fetching Users:", error);
        return error.response?.status || 500;
    }
};

export const CatagoriesDropdownApi = async () => {
    try {
        const response = await apiClient.get(`fapp-core-api/api/Categories`);
        return response;
    } catch (error: any) {
        console.error("Error fetching categories:", error);
        return error.response?.status || 500;
    }
};
export const SuppliersDropdownApi = async () => {
    try {
        const response = await apiClient.get(`fapp-core-api/api/Suppliers`);
        return response;
    } catch (error: any) {
        console.error("Error fetching suppliers:", error);
        return error.response?.status || 500;
    }
};
export const SalesRepLeadDropdownApi = async (id: any) => {
    try {
        const response = await apiClient.get(
            `fapp-core-api/api/SupplierSalesReps?supplierID=${id}`
        );
        return response;
    } catch (error: any) {
        console.error("Error fetching sales rep leads:", error);
        return error.response?.status || 500;
    }
};
export const getNegotiationData = async () => {
    const email = "akhilesh.g.singh@withavanadedev.onmicrosoft.com";
    try {
        const response = await apiClient.get(`/Negotiation?userEmail=${email}`);
        return response;
    } catch (error: any) {
        console.error('Error getting negotiation data:', error);
        return error.response?.status || 500;
    }
}

export const createNewSupplier = async (data: any) => {
    const { ID, Name = "-", SupplierLocation = "-" } = data.payload.newSupplier || {};

    const payload: any = {
        Name,
        SupplierLocation,
    };

    try {
        if (ID) {
            payload.ID = ID;
            return await apiClient.put(`fapp-core-api/api/Suppliers`, { ...payload, Status: true });
        }
        return await apiClient.post(`fapp-core-api/api/Suppliers`, { ...payload, Status: true });
    } catch (error: any) {
        console.error('Error creating/updating supplier:', error);
        return error.response?.status || 500;
    }
};

export const deleteSupplier = async (data: any) => {
    const payload = {
        ID: data.payload.removeSupplier.ID ? data.payload.removeSupplier.ID : "",
        Status: false
    }
    try {
        const response = await apiClient.put(`fapp-core-api/api/Suppliers`, payload);
        return response;
    } catch (error: any) {
        console.error('Error deleting supplier:', error);
        return error.response?.status || 500;
    }
}

export const createNewSalesRepLead = async (data: any) => {
    const { ID, SupplierID = "-", Name = "-", EmailAddress = "-", MobileNumber = "-" } = data.payload.newSalesRepLead || {};

    const payload: any = {
        SupplierID,
        Name,
        EmailAddress,
        MobileNumber,
    };

    try {
        if (ID) {
            payload.ID = ID;
            payload.Status = true;
            return await apiClient.put(`fapp-core-api/api/SupplierSalesReps`, payload);
        }
        return await apiClient.post(`fapp-core-api/api/SupplierSalesReps`, payload);
    } catch (error: any) {
        console.error('Error creating/updating sales rep lead:', error);
        return error.response?.status || 500;
    }
};

export const deleteSalesRepLead = async (data: any) => {

    const payload = {
        ID: data.payload.removeSalesRepLead.ID ? data.payload.removeSalesRepLead.ID : "",
        Status: false
    }
    try {
        const response = await apiClient.put(`fapp-core-api/api/SupplierSalesReps`, payload);
        return response;
    } catch (error: any) {
        console.error('Error deleting supplier:', error);
        return error.response?.status || 500;
    }
}
const getValue = <T>(value: T | undefined | null, fallback: T) =>
    value !== undefined && value !== null && value !== "" ? value : fallback;

const getNegotiationRoundDetails = (plan: any) => {
    const roundKeys = [
        "Preparation", "Round1", "Round2", "Round3", "Round4",
        "Round5", "Round6", "Round7", "Round8", "Round9", "Round10", "Finalization"
    ];
    return roundKeys
        .filter(key => plan?.[key])
        .map(key => ({
            RoundName: key,
            SelectedAction: plan[key]
        }));
};

const buildFinalData = (data: any) => {
    const basic = data.basicDetailsData || {};
    const power = data.powerPositionDetails?.powerPositionData || {};
    const target = data.TargetValueData || {};
    const classification = data.salesRepClassificationData || {};

    return {
        Name: getValue(basic.negotiationName, ""),
        LeadCountryId: getValue(basic.leadCountry, ""),
        CategoryId: getValue(basic.categoryName, ""),
        AdditionalSalesRep: getValue(basic.additionalSalesRep, ""),
        NegotiationTeam: getValue(basic.negotiationTeam, ""),
        OD: getValue(basic.od, ""),
        SupplierId: getValue(basic.suppliers, ""),
        SalesRepLeadId: getValue(basic.salesRepLead, ""),
        NegotiationDateMonth: getValue(basic.negotiationDateMonth, 0),
        NegotiationDateYear: getValue(basic.negotiationDateYear, 0),
        NegotiationImplementationMonth: getValue(basic.negotiationImplementationMonth, 0),
        NegotiationImplementationYear: getValue(basic.negotiationImplementationYear, 0),
        ValidityPeriod: getValue(basic.validityPeriod, 0),
        RelevantSpend: getValue(basic.relevantSpend, 0),
        Comment: basic.comment,
        PowerPositionQuestion1: power.supplierExistOrNot ? JSON.parse(power.supplierExistOrNot) : null,
        PowerPositionQuestion2: power.supplierAwareness ? JSON.parse(power.supplierAwareness) : null,
        PowerPositionQuestion3: power.supplierDependent ? JSON.parse(power.supplierDependent) : null,
        powerPositionTitle: data.powerPositionDetails?.powerPosition,
        PowerPositionID: data.powerPositionDetails?.powerPositionId,
        IsSavedForLater: data.IsSavedForLater !== false,
        Status: "In Progress",
        SupplyDemandBalance: getValue(target.supplyDemand, ""),
        PrecursorCostChanges: getValue(target.precursorCostChange, 0),
        NegotiationTarget: getValue(target.NegotiationTarget, 0),
        StopLimit: getValue(target.stopLimit, 0),
        GoinPosition: getValue(target.goInPosition, 0),
        NegotiationRounds: getValue(target.rounds, 0),
        PaymentTerms: getValue(target.paymentTerms, ""),
        IncoTerms: getValue(target.incoTerms, ""),
        LocalStock: getValue(target.localStock, ""),
        SummaryDetails: "Summary includes supplier history, current terms, and expectations.",
        ClassificationSettings: classification.classificationSettings
            ? JSON.stringify(classification.classificationSettings)
            : "",
        salesRepClassificationTitle: classification.classificationType || "",
        SalesRepClassificationID: classification.salesRepClassificationId || "",
        NegotiationRoundsDetails: getNegotiationRoundDetails(data.PlanNegotiationActions)
    };
};
export const sendNegotiationData = async (data: any) => {
    const finalData = buildFinalData(data);

    try {
        const response = data?.isFormUpdate?.state
            ? await apiClient.put(`fapp-core-api/api/Negotiation`, {
                ID: data?.isFormUpdate?.ID,
                ...finalData
            })
            : await apiClient.post(`fapp-core-api/api/Negotiation`, finalData);
        return response;
    } catch (error: any) {
        console.error("Error sending negotiation data:", error);
        return error.response?.status || 500;
    }
};
